import { render, staticRenderFns } from "./VarFormSetting.vue?vue&type=template&id=84c84824"
import script from "./VarFormSetting.vue?vue&type=script&lang=js"
export * from "./VarFormSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c84824')) {
      api.createRecord('84c84824', component.options)
    } else {
      api.reload('84c84824', component.options)
    }
    module.hot.accept("./VarFormSetting.vue?vue&type=template&id=84c84824", function () {
      api.rerender('84c84824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/SettingPages/VarFormSetting.vue"
export default component.exports